export default __webpack_public_path__ + "static/media/states.5053bfac.svg";